var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E6F8E684-5480-4F84-A402-23CCED6EECCE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Working",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.704031808
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landscape-Mode",
    transform: "translate(-75.000000, -179.000000)",
    fill: "#979797",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0123369,179 L80.9683604,182.037733 C82.0844367,181.215912 83.3283355,180.560777 84.6698561,180.098855 C91.8893662,177.612978 99.7571366,181.450346 102.243013,188.669856 C104.72889,195.889366 100.891522,203.757137 93.6720118,206.243013 C86.4525018,208.72889 78.5847313,204.891522 76.0988547,197.672012 L76.0988547,197.672012 L79.3668745,196.546742 C81.231282,201.961375 87.1321098,204.839401 92.5467424,202.974993 C97.9613749,201.110586 100.839401,195.209758 98.9749935,189.795126 C97.110586,184.380493 91.2097581,181.502467 85.7951256,183.366874 C84.9415904,183.66077 84.1422021,184.057751 83.4095964,184.546252 L87,188.236448 L75,191 L78.0123369,179 Z",
    id: "Rotate"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.d8777c04f8ef9d5b17462fdd766c0623.svg";
export { ForwardRef as ReactComponent };